import { authPost } from "@api";
import { DEPLOYMENT_URL } from "@constants";

import {
  SlackAppNotificationMappingRequestBody,
  SlackAppNotificationMappingTestResponse,
} from "@pages/settings/types";

export const testSlackAppNotificationMapping = (
  deploymentId: string,
  channel_id: string
) => {
  return authPost<
    SlackAppNotificationMappingRequestBody,
    SlackAppNotificationMappingTestResponse
  >(`${DEPLOYMENT_URL}/${deploymentId}/slack/notifications/test`, {
    channel_id: channel_id,
  });
};
